import React, { useState, useEffect, useRef } from "react";
import "../Dashboard.css";
import Select from "react-select";
import { useSearchParams } from "react-router-dom";
import PaginationBar from "../../UILibrary/PaginationBar";
import ListOfSuppliers from "./ListOfSuppliers";
import GalleryOfSuppliers from "./GalleryOfSuppliers";
import UserProfileComponent from "../SellerProfile/UserProfileComponent";
import Overlay from "../../UILibrary/Overlay";
import PdfImportButton from "./PdfImportButton";
import { useNavigate } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import rfpIcon from "../../../assets/rfpicon.svg";
import {
  // clearSelectedSupplier,
  getMarketplaceSuppliers,
} from "../../../store/supplierMarketplaceSlice";
import { setSelectedSupplier, clearSelectedSupplier } from "../../../store/authSlice";
import {
  analyzeRfpById,
  searchSuppliers,
  searchSuppliersByPromtText,
} from "../../../store/rfpSlice";
import {
  trackEngagementEvent,
  EngagementEventTypes,
} from "../../../store/engagementEventsSlice";

const paginationBarStyle = {
  position: "absolute",
  width: "100%",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: "30px",
  marginBottom: "20px",
  marginTop: "40px",
  padding: "10px",
  background: "transparent",
  bottom: 0,
  boxShadow: "none",
};
const customMultiSelectStyles = {
  menu: (provided) => ({
    ...provided,
    textAlign: "start",
    background: "#F7F7F7",
    padding: "10px",
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "220px",
    overflowY: "auto",
    paddingRight: "6px",
  }),
  control: (provided, state) => ({
    ...provided,
    ...provided,
    border: "none",
    background: "#F9F9F9",
    textAlign: "start",
    minHeight: "48px",
    height: "auto",
    boxShadow: state.isFocused
      ? "0 0 0 2px rgba(128, 128, 128, 0.5)"
      : provided.boxShadow,
    overflowY: "hidden",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#1D2639",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "lightgray"
      : state.isFocused
      ? "lightgray"
      : provided.backgroundColor,
    color: state.isSelected ? "black" : "black",
    padding: "6px",
    "&:active": {
      backgroundColor: "lightgray",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#B0B0B0",
  }),
};


const industries = [
  { code: "11", name: "Agriculture, Forestry, Fishing and Hunting" },
  { code: "21", name: "Mining, Quarrying, and Oil and Gas Extraction" },
  { code: "22", name: "Utilities" },
  { code: "23", name: "Construction" },
  { code: "31-33", name: "Manufacturing" },
  { code: "42", name: "Wholesale Trade" },
  { code: "44-45", name: "Retail Trade" },
  { code: "48-49", name: "Transportation and Warehousing" },
  { code: "51", name: "Information" },
  { code: "52", name: "Finance and Insurance" },
  { code: "53", name: "Real Estate and Rental and Leasing" },
  { code: "54", name: "Professional, Scientific, and Technical Services" },
  { code: "55", name: "Management of Companies and Enterprises" },
  {
    code: "56",
    name: "Administrative and Support and Waste Management and Remediation Services",
  },
  { code: "61", name: "Educational Services" },
  { code: "62", name: "Health Care and Social Assistance" },
  { code: "71", name: "Arts, Entertainment, and Recreation" },
  { code: "72", name: "Accommodation and Food Services" },
  { code: "81", name: "Other Services (except Public Administration)" },
];


const certifications = ["Certified", "Uncertified"];

const countryOptions = [
  { value: "US", label: "US" },
  { value: "Canada", label: "Canada" },
];

const stateOptions = {
  US: [
    { value: "Alabama", label: "Alabama" },
    { value: "Alaska", label: "Alaska" },
    { value: "Arizona", label: "Arizona" },
    { value: "Arkansas", label: "Arkansas" },
    { value: "California", label: "California" },
    { value: "Colorado", label: "Colorado" },
    { value: "Connecticut", label: "Connecticut" },
    { value: "Delaware", label: "Delaware" },
    { value: "Florida", label: "Florida" },
    { value: "Georgia", label: "Georgia" },
    { value: "Hawaii", label: "Hawaii" },
    { value: "Idaho", label: "Idaho" },
    { value: "Illinois", label: "Illinois" },
    { value: "Indiana", label: "Indiana" },
    { value: "Iowa", label: "Iowa" },
    { value: "Kansas", label: "Kansas" },
    { value: "Kentucky", label: "Kentucky" },
    { value: "Louisiana", label: "Louisiana" },
    { value: "Maine", label: "Maine" },
    { value: "Maryland", label: "Maryland" },
    { value: "Massachusetts", label: "Massachusetts" },
    { value: "Michigan", label: "Michigan" },
    { value: "Minnesota", label: "Minnesota" },
    { value: "Mississippi", label: "Mississippi" },
    { value: "Missouri", label: "Missouri" },
    { value: "Montana", label: "Montana" },
    { value: "Nebraska", label: "Nebraska" },
    { value: "Nevada", label: "Nevada" },
    { value: "New Hampshire", label: "New Hampshire" },
    { value: "New Jersey", label: "New Jersey" },
    { value: "New Mexico", label: "New Mexico" },
    { value: "New York", label: "New York" },
    { value: "North Carolina", label: "North Carolina" },
    { value: "North Dakota", label: "North Dakota" },
    { value: "Ohio", label: "Ohio" },
    { value: "Oklahoma", label: "Oklahoma" },
    { value: "Oregon", label: "Oregon" },
    { value: "Pennsylvania", label: "Pennsylvania" },
    { value: "Rhode Island", label: "Rhode Island" },
    { value: "South Carolina", label: "South Carolina" },
    { value: "South Dakota", label: "South Dakota" },
    { value: "Tennessee", label: "Tennessee" },
    { value: "Texas", label: "Texas" },
    { value: "Utah", label: "Utah" },
    { value: "Vermont", label: "Vermont" },
    { value: "Virginia", label: "Virginia" },
    { value: "Washington", label: "Washington" },
    { value: "West Virginia", label: "West Virginia" },
    { value: "Wisconsin", label: "Wisconsin" },
    { value: "Wyoming", label: "Wyoming" },
  ],
  Canada: [
    { value: "Alberta", label: "Alberta" },
    { value: "British Columbia", label: "British Columbia" },
    { value: "Manitoba", label: "Manitoba" },
    { value: "New Brunswick", label: "New Brunswick" },
    { value: "Newfoundland and Labrador", label: "Newfoundland and Labrador" },
    { value: "Nova Scotia", label: "Nova Scotia" },
    { value: "Ontario", label: "Ontario" },
    { value: "Prince Edward Island", label: "Prince Edward Island" },
    { value: "Quebec", label: "Quebec" },
    { value: "Saskatchewan", label: "Saskatchewan" },
    { value: "Northwest Territories", label: "Northwest Territories" },
    { value: "Nunavut", label: "Nunavut" },
    { value: "Yukon", label: "Yukon" },
  ],
};

const industryOptions = industries.map((industry) => ({
  value: industry,
  label: industry,
}));

const certificationOptions = certifications.map((cert) => ({
  value: cert,
  label: cert,
}));

const customStyles = {
  menu: (provided) => ({
    ...provided,
    textAlign: "start",
    background: "#F7F7F7",
    borderRadius: "0.5rem",
  }),
  control: (provided, state) => ({
    ...provided,
    border: "none",
    background: "#F5F5F5",
    textAlign: "start",
    height: "48px",
    borderRadius: "0.5rem",
    boxShadow: state.isFocused
      ? "0 0 0 2px rgba(128, 128, 128, 0.5)"
      : provided.boxShadow,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#1D2639",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#F5F5F5"
      : state.isFocused
      ? "#F5F5F5"
      : provided.backgroundColor,
    color: "black",
    padding: "6px",
    borderRadius: "0.5rem",
    "&:active": {
      backgroundColor: "#F5F5F5",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#B0B0B0",
  }),
};

const Marketplace = () => {
  const [selectedCard, setSelectedCard] = useState(false);
  const [viewType, setViewType] = useState("gallery");
  const [isUserProfileOpen, setIsUserProfileOpen] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const [isImportCompleted, setImportCompleted] = useState(false);
  const [isSummuryGenerated, setSummuryGenerated] = useState(false);
  const [isSearchInProgress, setSearchInProgress] = useState(false);
  const [isSearchTrigered, setSearchTrigered] = useState(false);
  const [isMoreSuppliersClicked, setMoreSuppliersClicked] = useState(false);
  const [isRecommendedSuppliersLoaded, setRecommendedSuppliersLoaded] =
    useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isIndustrySelected, setIndustrySelected] = useState(false);
    const [naicsData, setNaicsData] = useState([]);
    const [NaicsCodes, setNaicsCodes] = useState([]);

  const [tempSearchQuery, setTempSearchQuery] = useState("");
  const suppliers = useSelector(
    (state) => state?.marketplaceSuppliers?.suppliers
  );
  const totalCount = useSelector(
    (state) => state?.marketplaceSuppliers?.totalCount
  );
  const [searchParams, setSearchParams] = useSearchParams();
  const pageFromUrl = Number(searchParams.get("page")) || 1;

  const [currentPage, setCurrentPage] = useState(pageFromUrl);

  const [showFilters, setShowFilters] = useState(false);
  const itemsPerPage = 50;
  const dispatch = useDispatch();
  const { summaryText, analyzing, fileId, loading } = useSelector(
    (state) => state.rfp
  );
  const [selectedFilters, setSelectedFilters] = useState({
      Country: [],
      State: [],
      Industry: { code: "", name: "" },
      NAICS: [],
      Certification: [],
      City: [],
    });

  const scrollContainerRef = useRef(null);

  const [cityInput, setCityInput] = useState("");

  const regenerateText = () => {
    dispatch(analyzeRfpById(fileId));
  };

  const handleSearch = () => {
    setTempSearchQuery(searchQuery);
    dispatch(searchSuppliersByPromtText({ text: searchQuery }));
    dispatch(
      trackEngagementEvent({
        eventType: EngagementEventTypes.AI_MATCH_GENERATED,
        metadata: { source: "marketplace", query: searchQuery },
      }),
    );
    setSearchInProgress(true);
    setSearchTrigered(true);
    setSearchQuery("");
  };
    const handleIndustryChange = (selectedOption) => {

    const selectedValue = selectedOption ? selectedOption.value : "";
    const selectedLabel = selectedOption ? selectedOption.label : "";
    setSelectedFilters((prev) => ({
      ...prev,
      Industry: { code: selectedValue, name: selectedLabel },

      NAICS: [],
    }));
    setIndustrySelected(true);

  };

    const handleAdditionalNaicsChange = (selectedOptions) => {
      const selectedCodes = selectedOptions?.map((option) => option.value) || [];
  
      setNaicsCodes(selectedCodes);
  
      setSelectedFilters((prev) => ({
        ...prev,
        NAICS: selectedCodes,
      }));
    };
    const BASE_API_URL =
      "https://api.census.gov/data/2022/ecnbasic?get=NAICS2022,NAICS2022_LABEL,NAME,GEO_ID,ESTAB,RCPTOT,EMP&for=us:*&key=ca9f7d90d4ea4a77f056e0a1ea74f0a8660366b6";
  
    useEffect(() => {
      if (selectedFilters.Industry.code) {
        const apiUrl = `${BASE_API_URL}&NAICS2022=${selectedFilters.Industry.code}*`;
        fetch(apiUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((data) => {
            if (data.length > 1) {
              const formattedData = data
                .slice(1)
                .map(([code, description, ...rest]) => ({
                  value: code,
                  label: `${code} - ${description}`,
                  additionalInfo: rest,
                }));
              setNaicsData(formattedData);
              // setNoDataMessage("");
            } else {
              setNaicsData([]);
              // setNoDataMessage("No NAICS data available.");
            }
          })
          .catch((error) => {
            console.error("Error fetching NAICS data:", error);
            // setNoDataMessage("Error fetching NAICS data.");
            setNaicsData([]);
          });
      }
    }, [selectedFilters.Industry]);

  useEffect(() => {
    dispatch(
      getMarketplaceSuppliers({ page: currentPage, limit: itemsPerPage })
    );
  }, [currentPage, dispatch]);

useEffect(() => {
  if (!loading && (isSummuryGenerated || isSearchTrigered)) {
    const timer = setTimeout(() => {
      setSummuryGenerated(false);
      setSearchTrigered(false);
      setRecommendedSuppliersLoaded(true);
    }, 1000);
    return () => clearTimeout(timer);
  }
}, [loading, isSummuryGenerated, isSearchTrigered]);



  const clearSearch = () => {
    setRecommendedSuppliersLoaded(false);
    setMoreSuppliersClicked(false);
    setSearchInProgress(false);
    setSearchTrigered(false);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    setCurrentPage(pageFromUrl);
  }, [pageFromUrl]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    setSearchParams({ page: page.toString() });
  };

  const removeTag = (type, value) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [type]: prev[type].filter((v) => v !== value),
    }));
  };

  const handleCitySubmit = () => {
    if (cityInput.trim() && !selectedFilters.City.includes(cityInput.trim())) {
      setSelectedFilters((prev) => ({
        ...prev,
        City: [...prev.City, cityInput.trim()],
      }));
      setCityInput("");
    }
  };

  const handleCancel = () => {
    setShowFilters(false);
    setSelectedFilters({
      Country: [],
      State: [],
      Industry: [],
      Certification: [],
      City: [],
    });
    setCityInput("");
  };
  const handleFilters = () => {
    setShowFilters(false);
      const filters = {
      country: selectedFilters.Country,
      state: selectedFilters.State,
      identifierNAICSCode: selectedFilters.NAICS,
      certification: selectedFilters.Certification,
      city: selectedFilters.City,
    }
    dispatch(getMarketplaceSuppliers({
    page: currentPage,
    limit: itemsPerPage,
    filters
  }));
    setSelectedFilters({
      Country: [],
      State: [],
      Industry: [],
      Certification: [],
      City: [],
    });
    setCityInput("");
    setIndustrySelected(false);
  };

  useEffect(() => {
    setSelectedFilters((prev) => ({
      ...prev,
      State: [],
    }));
  }, [selectedFilters.Country]);

  const handleSelectChange = (type, selectedOptions) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [type]: selectedOptions ? selectedOptions.map((opt) => opt.value) : [],
    }));
  };

  const handleSelectCountryChange = (type, selectedOption) => {
  setSelectedFilters((prev) => ({
    ...prev,
    [type]: selectedOption ? [selectedOption.value] : [],
  }));
};


  const handleCardSelection = (user) => {
    if (isClosed) {
      setSelectedCard(false);
      setIsUserProfileOpen(false);
      setIsClosed(false);
    }
    setSelectedCard(true);
    dispatch(setSelectedSupplier(user));
    dispatch(
      trackEngagementEvent({
        eventType: EngagementEventTypes.PROFILE_VIEWED,
        supplierId: user?._id || user?.id,
        metadata: {
          source: "marketplace",
          name: user?.company?.name,
        },
      }),
    );
    setIsUserProfileOpen(true);
  };

  const handleCloseUserProfile = () => {
    dispatch(clearSelectedSupplier());
    setSelectedCard(false);
    setIsUserProfileOpen(false);
    setIsClosed(true);
  };
  const closePopUp = () => {
    isSummuryGenerated ? setSummuryGenerated(false) : setImportCompleted(false);
  };

  const onNext = () => {
    setImportCompleted(false);
    setSummuryGenerated(true);
    dispatch(searchSuppliers({ text: summaryText }));
  };
  const toggleView = () => {
    setViewType((prevView) => (prevView === "gallery" ? "list" : "gallery"));
  };

  return (
    <>
      <div fluid ref={scrollContainerRef} style={{ position: "relative" }}>
        <div className="flex justify-between items-center">
          <div className="filter-container">
            <div style={{ marginLeft: "31px", display: "flex" }}>
              <div style={{ position: "relative", display: "inline-block" }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  style={{
                    position: "absolute",
                    left: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                  }}
                >
                  <g clipPath="url(#clip0_180_58425)">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8.75021 1.66699C7.62071 1.66709 6.5076 1.9373 5.50376 2.45507C4.49992 2.97285 3.63446 3.72317 2.97957 4.64345C2.32469 5.56373 1.89939 6.62728 1.73913 7.74536C1.57888 8.86344 1.68834 10.0036 2.05836 11.0708C2.42838 12.138 3.04825 13.1012 3.86624 13.8801C4.68423 14.659 5.67663 15.231 6.76064 15.5483C7.84465 15.8657 8.98883 15.9192 10.0977 15.7044C11.2066 15.4896 12.2481 15.0128 13.1352 14.3137L16.1785 17.357C16.3357 17.5088 16.5462 17.5928 16.7647 17.5909C16.9832 17.589 17.1922 17.5013 17.3467 17.3468C17.5012 17.1923 17.5889 16.9833 17.5908 16.7648C17.5927 16.5463 17.5087 16.3358 17.3569 16.1787L14.3135 13.1353C15.1369 12.0908 15.6495 10.8357 15.7928 9.51343C15.9361 8.1912 15.7042 6.85534 15.1237 5.65874C14.5433 4.46213 13.6376 3.45312 12.5105 2.74718C11.3833 2.04125 10.0802 1.6669 8.75021 1.66699ZM3.33354 8.75033C3.33354 7.31374 3.90423 5.93599 4.92005 4.92016C5.93587 3.90434 7.31362 3.33366 8.75021 3.33366C10.1868 3.33366 11.5646 3.90434 12.5804 4.92016C13.5962 5.93599 14.1669 7.31374 14.1669 8.75033C14.1669 10.1869 13.5962 11.5647 12.5804 12.5805C11.5646 13.5963 10.1868 14.167 8.75021 14.167C7.31362 14.167 5.93587 13.5963 4.92005 12.5805C3.90423 11.5647 3.33354 10.1869 3.33354 8.75033Z"
                      fill="#7B7B7B"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_180_58425">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

                <input
                  type="text"
                  value={searchQuery}
                  placeholder="Input your prompt to match your search"
                  aria-label="Search"
                  className="supplier-search-input pl-[35px] text-[#A8A8A8] italic font-normal"
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>

              <div className="flex flex-row gap-4">
                <button
                  onClick={handleSearch}
                  type="submit"
                  className="flex items-center gap-2 px-4 py-2 text-white rounded-lg bg-[#08F] font-semibold ml-2 border-none cursor-pointer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_180_58425)">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.75021 1.66699C7.62071 1.66709 6.5076 1.9373 5.50376 2.45507C4.49992 2.97285 3.63446 3.72317 2.97957 4.64345C2.32469 5.56373 1.89939 6.62728 1.73913 7.74536C1.57888 8.86344 1.68834 10.0036 2.05836 11.0708C2.42838 12.138 3.04825 13.1012 3.86624 13.8801C4.68423 14.659 5.67663 15.231 6.76064 15.5483C7.84465 15.8657 8.98883 15.9192 10.0977 15.7044C11.2066 15.4896 12.2481 15.0128 13.1352 14.3137L16.1785 17.357C16.3357 17.5088 16.5462 17.5928 16.7647 17.5909C16.9832 17.589 17.1922 17.5013 17.3467 17.3468C17.5012 17.1923 17.5889 16.9833 17.5908 16.7648C17.5927 16.5463 17.5087 16.3358 17.3569 16.1787L14.3135 13.1353C15.1369 12.0908 15.6495 10.8357 15.7928 9.51343C15.9361 8.1912 15.7042 6.85534 15.1237 5.65874C14.5433 4.46213 13.6376 3.45312 12.5105 2.74718C11.3833 2.04125 10.0802 1.6669 8.75021 1.66699ZM3.33354 8.75033C3.33354 7.31374 3.90423 5.93599 4.92005 4.92016C5.93587 3.90434 7.31362 3.33366 8.75021 3.33366C10.1868 3.33366 11.5646 3.90434 12.5804 4.92016C13.5962 5.93599 14.1669 7.31374 14.1669 8.75033C14.1669 10.1869 13.5962 11.5647 12.5804 12.5805C11.5646 13.5963 10.1868 14.167 8.75021 14.167C7.31362 14.167 5.93587 13.5963 4.92005 12.5805C3.90423 11.5647 3.33354 10.1869 3.33354 8.75033Z"
                        fill="#fff"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_180_58425">
                        <rect width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  Search
                </button>
                <PdfImportButton setImportCompleted={setImportCompleted} />
                <div className="">
                  <button
                    onClick={() => setShowFilters(!showFilters)}
                    className="inline-flex h-[42px] px-3 py-2 items-center gap-2 bg-[#F6F6F6] rounded-[8px] border text-sm text-[#1D2739]"
                  >
                    Filters
                  </button>

                                      {showFilters && (
                                        <>
                                          <Overlay />
                                          <div className="absolute flex items-center justify-center left-1/2 top-0 transform -translate-x-1/2 z-[1100]">
                                            <div className="flex flex-col items-center justify-start px-[51px] pb-[34px] pt-0 w-[658px] h-[810px] rounded bg-white shadow-[0_0_10px_rgba(0,0,0,0.1)] mt-[5px] overflow-auto">
                                              <span className="mt-16 mb-8 text-[#1D2739] text-lg text-left flex justify-start items-left font-semibold">
                                                Filters
                                              </span>
                  
                                              {/* Country */}
                                              <div className="w-full mb-6">
                                                <label className="block text-[#1D2639] text-base text-start font-normal">
                                                  Country
                                                </label>
                                                <Select
                                                  isMulti
                                                  options={countryOptions}
                                                  styles={customStyles}
                                                  value={selectedFilters.Country.map((c) => ({
                                                    value: c,
                                                    label: c,
                                                  }))}
                                                  onChange={(selected) =>
                                                    handleSelectChange("Country", selected)
                                                  }
                                                />
                                              </div>
                  
                                              <div className="w-full mb-6">
                                                <label className="block text-[#1D2639] text-base text-start font-normal">
                                                  State/Province
                                                </label>
                                                <Select
                                                  isMulti
                                                  styles={customStyles}
                                                  options={selectedFilters.Country.flatMap(
                                                    (country) => stateOptions[country] || []
                                                  )}
                                                  value={selectedFilters.State.map((s) => ({
                                                    value: s,
                                                    label: s,
                                                  }))}
                                                  onChange={(selected) =>
                                                    handleSelectChange("State", selected)
                                                  }
                                                />
                                              </div>
                  
                                              <div className="w-full mb-6">
                                                <label
                                                  htmlFor="city"
                                                  className="block text-[#1D2639] text-base text-start font-normal"
                                                >
                                                  City
                                                </label>
                                                <input
                                                  type="text"
                                                  id="city"
                                                  placeholder="Enter a city"
                                                  className="w-full h-12 px-4 bg-[#F9F9F9] border-2 border-gray-300 rounded-lg focus:outline-none"
                                                  value={cityInput}
                                                  onChange={(e) => setCityInput(e.target.value)}
                                                  onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                      e.preventDefault();
                                                      handleCitySubmit();
                                                    }
                                                  }}
                                                />
                  
                                                {selectedFilters.City.length > 0 && (
                                                  <div className="flex flex-wrap gap-2 mt-2">
                                                    {selectedFilters.City.map((city, index) => (
                                                      <div
                                                        key={index}
                                                        className="flex items-center gap-1 px-2 py-1 bg-gray-100 text-[#1D2639] rounded-sm text-sm"
                                                      >
                                                        {city}
                                                        <button
                                                          onClick={() => removeTag("City", city)}
                                                          className="text-[#1D2639] ml-1"
                                                        >
                                                          &times;
                                                        </button>
                                                      </div>
                                                    ))}
                                                  </div>
                                                )}
                                              </div>
                  
                                              <div className="w-full mb-6">
                                                <label className="block text-[#1D2639] text-base text-start font-normal">
                                                  Industry
                                                </label>
                                                {/* <Select
                                                  isMulti
                                                  styles={customStyles}
                                                  options={industryOptions}
                                                  value={selectedFilters.Industry.map((i) => ({
                                                    value: i,
                                                    label: i,
                                                  }))}
                                                  onChange={(selected) =>
                                                    handleIndustryChange(selected)
                                                  }
                                                /> */}
                                                <Select
                                                  options={industries.map(({ code, name }) => ({
                                                    value: code,
                                                    label: name,
                                                  }))}
                                                  value={
                                                    selectedFilters.Industry.name
                                                      ? {
                                                          value: selectedFilters.Industry.code,
                                                          label: selectedFilters.Industry.name,
                                                        }
                                                      : ""
                                                  }
                                                  onChange={handleIndustryChange}
                                                  styles={customStyles}
                                                  placeholder="Select an Industry..."
                                                  isClearable
                                                  isSearchable
                                                />
                                              </div>
                                              {isIndustrySelected && (
                                                <div className="w-full mb-6">
                                                  <label className="block text-[#1D2639] text-base text-start font-normal">
                                                    NAICS Codes{" "}
                                                    <span className="text-red-500">*</span>
                                                  </label>
                                                  <Select
                                                    options={naicsData.map(
                                                      ({ value, label }) => ({
                                                        value,
                                                        label,
                                                      })
                                                    )}
                                                    value={
                                                      selectedFilters.NaicsCodes?.length
                                                        ? selectedFilters.NaicsCodes.map(
                                                            (naic) => ({
                                                              value: naic.code,
                                                              label: naic.name,
                                                            })
                                                          )
                                                        : naicsData.filter((option) =>
                                                            NaicsCodes.includes(option.value)
                                                          )
                                                    }
                                                    onChange={handleAdditionalNaicsChange}
                                                    styles={customMultiSelectStyles}
                                                    isMulti
                                                    placeholder="Select NAICS Codes..."
                                                  />
                                                </div>
                                              )}
                  
                                              <div className="w-full mb-6">
                                                <label className="block text-[#1D2639] text-base text-start font-normal">
                                                  Certification
                                                </label>
                                                <Select
                                                  isMulti
                                                  styles={customStyles}
                                                  options={certificationOptions}
                                                  value={selectedFilters.Certification.map(
                                                    (c) => ({
                                                      value: c,
                                                      label: c,
                                                    })
                                                  )}
                                                  onChange={(selected) =>
                                                    handleSelectChange("Certification", selected)
                                                  }
                                                />
                                              </div>
                  
                                              <button
                                                className={`flex mt-10 w-[382px] h-[50px] max-h-[64px] px-[38px] py-[22px] justify-center items-center gap-[10px] shrink-0 rounded-[8px] ${isIndustrySelected && selectedFilters.NAICS.length < 1 ? 'bg-gray-200' : 'bg-[#EAF524]'} text-black`}
                                                onClick={handleFilters}
                                                disabled={isIndustrySelected && selectedFilters?.NAICS?.length < 1}
                                              >
                                                Apply Filters
                                              </button>
                                              <span
                                                className="text-[#7E7E7E] mt-2"
                                                onClick={() => handleCancel()}
                                              >
                                                Cancel
                                              </span>
                                            </div>
                                          </div>
                                        </>
                                      )}

                  {/* {showFilters && (
                    <>
                      <Overlay />
                      <div className="absolute flex items-center justify-center left-1/2 top-0 transform -translate-x-1/2 z-[1100]">
                        <div className="flex flex-col items-center justify-start px-[51px] pb-[34px] pt-0 w-[658px] h-[810px] rounded bg-white shadow-[0_0_10px_rgba(0,0,0,0.1)] mt-[60px] overflow-auto">
                          <span className="mt-16 mb-16 text-[#1D2739] text-lg text-left flex justify-start items-left font-semibold">
                            Filters
                          </span>

                
                          <div className="w-full mb-6">
                            <label className="block text-[#1D2639] text-base text-start font-normal">
                              Country
                            </label>
                            <Select
                              options={countryOptions}
                              styles={customStyles}
                              value={selectedFilters.Country.map((c) => ({
                                value: c,
                                label: c,
                              }))}
                              onChange={(selected) =>
                                handleSelectCountryChange("Country", selected)
                              }
                            />
                          </div>

                   
                          <div className="w-full mb-6">
                            <label className="block text-[#1D2639] text-base text-start font-normal">
                              State/Province
                            </label>
                            <Select
                              isMulti
                              styles={customStyles}
                              options={selectedFilters.Country.flatMap(
                                (country) => stateOptions[country] || []
                              )}
                              value={selectedFilters.State.map((s) => ({
                                value: s,
                                label: s,
                              }))}
                              onChange={(selected) =>
                                handleSelectChange("State", selected)
                              }
                            />
                          </div>
  
                          <div className="w-full mb-6">
                            <label
                              htmlFor="city"
                              className="block text-[#1D2639] text-base text-start font-normal"
                            >
                              City <span className="text-base text-gray-500">(press Enter to add multiple)</span>
                            </label>
                            <input
                              type="text"
                              id="city"
                              placeholder="Enter a city"
                              className="w-full h-12 px-4 bg-[#F9F9F9] border-2 border-gray-300 rounded-lg focus:outline-none"
                              value={cityInput}
                              onChange={(e) => setCityInput(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  handleCitySubmit();
                                }
                              }}
                            />

              
                            {selectedFilters.City.length > 0 && (
                              <div className="flex flex-wrap gap-2 mt-2">
                                {selectedFilters.City.map((city, index) => (
                                  <div
                                    key={index}
                                    className="flex items-center gap-1 px-2 py-1 bg-gray-100 text-[#1D2639] rounded-sm text-sm"
                                  >
                                    {city}
                                    <button
                                      onClick={() => removeTag("City", city)}
                                      className="text-[#1D2639] ml-1"
                                    >
                                      &times;
                                    </button>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>

        
                          <div className="w-full mb-6">
                            <label className="block text-[#1D2639] text-base text-start font-normal">
                              Industry
                            </label>
                            <Select
                              isMulti
                              styles={customStyles}
                              options={industryOptions}
                              value={selectedFilters.Industry.map((i) => ({
                                value: i,
                                label: i,
                              }))}
                              onChange={(selected) =>
                                handleSelectChange("Industry", selected)
                              }
                            />
                          </div>


                          <div className="w-full mb-6">
                            <label className="block text-[#1D2639] text-base text-start font-normal">
                              Certification
                            </label>
                            <Select
                              isMulti
                              styles={customStyles}
                              options={certificationOptions}
                              value={selectedFilters.Certification.map((c) => ({
                                value: c,
                                label: c,
                              }))}
                              onChange={(selected) =>
                                handleSelectChange("Certification", selected)
                              }
                            />
                          </div>

                          <button
                            className="flex mt-10 w-[382px] h-[50px] max-h-[64px] px-[38px] py-[22px] justify-center items-center gap-[10px] shrink-0 rounded-[8px] bg-[#EAF524] text-black"
                            onClick={handleFilters}
                          >
                            Apply Filters
                          </button>
                          <span
                            className="text-[#7E7E7E] mt-2"
                            onClick={() => handleCancel()}
                          >
                            Cancel
                          </span>
                        </div>
                      </div>
                    </>
                  )} */}
                </div>
              </div>
            </div>
          </div>

          <div className="toggle-views">
            <div className="view-icons">
              <svg
                className={`icon ${viewType === "gallery" ? "active" : ""}`}
                onClick={toggleView}
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
              >
                <path
                  d="M3.88276 3.88184C3.55513 3.88184 3.24093 4.01198 3.00927 4.24365C2.77761 4.47531 2.64746 4.78951 2.64746 5.11713V12.5289C2.64746 12.8565 2.77761 13.1707 3.00927 13.4024C3.24093 13.634 3.55513 13.7642 3.88276 13.7642H12.5298C12.8574 13.7642 13.1716 13.634 13.4033 13.4024C13.635 13.1707 13.7651 12.8565 13.7651 12.5289V5.11713C13.7651 4.78951 13.635 4.47531 13.4033 4.24365C13.1716 4.01198 12.8574 3.88184 12.5298 3.88184H3.88276ZM5.11805 11.2936V6.35242H11.2945V11.2936H5.11805ZM3.88276 16.2348C3.55513 16.2348 3.24093 16.3649 3.00927 16.5966C2.77761 16.8282 2.64746 17.1425 2.64746 17.4701V24.8818C2.64746 25.2095 2.77761 25.5237 3.00927 25.7553C3.24093 25.987 3.55513 26.1171 3.88276 26.1171H12.5298C12.8574 26.1171 13.1716 25.987 13.4033 25.7553C13.635 25.5237 13.7651 25.2095 13.7651 24.8818V17.4701C13.7651 17.1425 13.635 16.8282 13.4033 16.5966C13.1716 16.3649 12.8574 16.2348 12.5298 16.2348H3.88276ZM5.11805 23.6465V18.7054H11.2945V23.6465H5.11805ZM16.2357 5.11713C16.2357 4.78951 16.3658 4.47531 16.5975 4.24365C16.8292 4.01198 17.1434 3.88184 17.471 3.88184H26.118C26.4457 3.88184 26.7599 4.01198 26.9915 4.24365C27.2232 4.47531 27.3533 4.78951 27.3533 5.11713V12.5289C27.3533 12.8565 27.2232 13.1707 26.9915 13.4024C26.7599 13.634 26.4457 13.7642 26.118 13.7642H17.471C17.1434 13.7642 16.8292 13.634 16.5975 13.4024C16.3658 13.1707 16.2357 12.8565 16.2357 12.5289V5.11713ZM18.7063 6.35242V11.2936H24.8828V6.35242H18.7063ZM17.471 16.2348C17.1434 16.2348 16.8292 16.3649 16.5975 16.5966C16.3658 16.8282 16.2357 17.1425 16.2357 17.4701V24.8818C16.2357 25.2095 16.3658 25.5237 16.5975 25.7553C16.8292 25.987 17.1434 26.1171 17.471 26.1171H26.118C26.4457 26.1171 26.7599 25.987 26.9915 25.7553C27.2232 25.5237 27.3533 25.2095 27.3533 24.8818V17.4701C27.3533 17.1425 27.2232 16.8282 26.9915 16.5966C26.7599 16.3649 26.4457 16.2348 26.118 16.2348H17.471ZM18.7063 23.6465V18.7054H24.8828V23.6465H18.7063Z"
                  fill="#1D2739"
                />
              </svg>
              <svg
                className={`icon ${viewType === "list" ? "active" : ""}`}
                onClick={toggleView}
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
              >
                <path
                  d="M2.64648 5.11719H27.3524V7.58778H2.64648V5.11719ZM2.64648 13.7642H27.3524V16.2348H2.64648V13.7642ZM3.88178 22.4113H2.64648V24.8819H27.3524V22.4113H26.1171H3.88178Z"
                  fill="#1D2739"
                />
              </svg>
            </div>
          </div>
        </div>

        {viewType === "list" ? (
          <ListOfSuppliers
            onCardClick={handleCardSelection}
            isRecommendedSuppliersLoaded={isRecommendedSuppliersLoaded}
            clearSearch={clearSearch}
            setMoreSuppliersClicked={setMoreSuppliersClicked}
            isMoreSuppliersClicked={isMoreSuppliersClicked}
            isSearchInProgress={isSearchInProgress}
            searchQuery={tempSearchQuery}
          />
        ) : (
          <GalleryOfSuppliers
            onCardClick={handleCardSelection}
            isRecommendedSuppliersLoaded={isRecommendedSuppliersLoaded}
            clearSearch={clearSearch}
            isSearchInProgress={isSearchInProgress}
            setMoreSuppliersClicked={setMoreSuppliersClicked}
            isMoreSuppliersClicked={isMoreSuppliersClicked}
            searchQuery={tempSearchQuery}
          />
        )}

        {isUserProfileOpen && <Overlay />}
        {selectedCard && (
          <div
            className="additional-bar"
            style={{
              width: "500px",
              position: "fixed",
              right: 0,
              top: 0,
              height: "100vh",
              background: "white",
              zIndex: 1100,
            }}
          >
            <UserProfileComponent
              // supplier={selectedSupplier}
              onClose={handleCloseUserProfile}
              backUrl="/dashboard/marketplace"
            />
          </div>
        )}
        {isImportCompleted && (
          <>
            <Overlay />
            <div className="popup-import-container">
              <div className="inline-flex flex-col px-[51px] pb-[34px] w-[618px] max-h-[80vh] rounded-[8px] bg-white shadow-md mt-[60px] overflow-y-auto">
                <p className="mt-4 mb-2 text-left">AI RFP Summary text</p>
                {!analyzing && (
                  <p className="text-left text-[#7B7B7B]">{summaryText}</p>
                )}

                <div className="mt-4 flex">
                  <button
                    className="text-[#7B7B7B] flex flex-row justify-start items-center text-[19px] bg-[rgba(227,227,227,0.63)] py-[7px] px-[10px] rounded-lg"
                    onClick={regenerateText}
                  >
                    {analyzing ? "Analyzing" : "Regenerate"}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                      className={`ml-2 ${analyzing ? "animate-spin" : ""}`}
                    >
                      <g clip-path="url(#clip0_339_17900)">
                        <path
                          d="M11.5 6C11.5 9 9.305 11 6.597 11C4.396 11 2.62 9.8325 2 8M1.5 6C1.5 3 3.695 1 6.4035 1C8.604 1 10.379 2.1675 11 4"
                          stroke="#7B7B7B"
                          stroke-width="1.33333"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M4 8.5L2 8L1.5 10M9 3.5L11 4L11.5 2"
                          stroke="#7B7B7B"
                          stroke-width="1.33333"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_339_17900">
                          <rect
                            width="12"
                            height="12"
                            fill="white"
                            transform="translate(0.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </button>
                </div>

                <div className="bottom-buttons">
                  <button onClick={closePopUp} className="cancel-button">
                    Cancel
                  </button>
                  <button
                    onClick={onNext}
                    disabled={analyzing}
                    className={`flex justify-center items-center rounded-[3.797px] w-[76.897px] h-[31.328px] px-[11.392px] py-[5.696px] outline-none border-none ${
                      analyzing
                        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                        : "bg-[#EAF524] text-black"
                    }`}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </>
        )}

        {(isSummuryGenerated || isSearchTrigered) && (
          <>
            <Overlay />
            <div className="popup-import-container">
              <div className="flex justify-center items-center flex-col px-[51px] pb-[34px] w-[618px] h-[415px] rounded-[8px] bg-white shadow-md mt-[60px] overflow-y-auto">
                <div className="flex justify-center items-center flex-col">
                  <img
                    src={rfpIcon}
                    alt="rfp icon"
                    className="spinning mb-4"
                  ></img>
                  <span className="text-[#1D2739] text-base flex justify-center items-center text-center">
                    {isSearchTrigered
                      ? "Searching recommendations..."
                      : "Generating recommendations..."}
                  </span>
                </div>
              </div>
            </div>
          </>
        )}
        {suppliers.length > 0 && (
          <div className="mt-40">
            <PaginationBar
              currentPage={currentPage}
              totalPages={
                isRecommendedSuppliersLoaded || isSearchTrigered
                  ? 1
                  : Math.ceil(totalCount / itemsPerPage)
              }
              handlePageChange={handlePageChange}
              paginationBarStyle={paginationBarStyle}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default Marketplace;
